import React from 'react';
import { DragonDropWrapper } from '../../../../../shared/DragonDrop/DragonDrop';
import AudioComponent from '../../body/AudioComponent';
import PDFdownloadButton from '../../body/PDFdownloadButton';

const data = {
  DragonDrop: {
    type: 'bench',
    ptype: 'start',
    title: 'Start',
    options: {
      'option-1': {
        id: 'option-1',
        ptype: 'labeled',
        content: 'Good job listening to mommy the first time I asked!',
      },
      'option-2': {
        id: 'option-2',
        ptype: 'labeled',
        content:
          'I heard that you did a great job listening at school today. Way to go!',
      },
      'option-3': {
        id: 'option-3',
        ptype: 'labeled',
        content: 'I like it when you say please!',
      },
      'option-4': {
        id: 'option-4',
        ptype: 'labeled',
        content:
          'Alright! You put away your toys without my even asking! Thank you!',
      },
      'option-5': {
        id: 'option-5',
        ptype: 'labeled',
        content: 'You really worked hard on finishing that puzzle, great job!',
      },
      'option-6': {
        id: 'option-6',
        ptype: 'unlabeled',
        content: 'Good Job!',
      },
      'option-7': {
        id: 'option-7',
        ptype: 'unlabeled',
        content: 'Great Work at school!',
      },
      'option-8': {
        id: 'option-8',
        ptype: 'unlabeled',
        content: "That's nice.",
      },
      'option-9': {
        id: 'option-9',
        ptype: 'unlabeled',
        content: 'You are great!',
      },
      'option-10': {
        id: 'option-10',
        ptype: 'unlabeled',
        content: 'High Five!',
      },
    },
    columns: {
      'column-1': {
        id: 'column-1',
        title: 'Start',
        optionIds: [
          'option-9',
          'option-3',
          'option-4',
          'option-6',
          'option-7',
          'option-10',
          'option-5',
          'option-1',
          'option-8',
          'option-2',
        ],
      },
      'column-2': {
        id: 'column-2',
        title: 'Labeled',
        optionIds: [],
      },
      'column-3': {
        id: 'column-3',
        title: 'Unlabeled',
        optionIds: [],
      },
    },
    columnOrder: ['column-1', 'column-2', 'column-3'],
    showErrorMessage: false,
  },
};

const LabeledPraiseActivity = () => {
  return (
    <div>
      <section className='text-left text-lg px-4 flex flex-col gap-2'>
        <p className='text-center p-4 text-3xl font-bold'>
          See if you can identify the labeled and unlabeled praise. In these
          examples, which praise do you think a child might prefer?
        </p>
        <p>
          <b>Labeled praise</b> is sincere, enthusiastic, and specific about the
          behavior you like.
        </p>
        <p>
          <b>Unlabeled praise</b> is praise that is general and not specific
          about the behavior you like. All praise is good, but LABELED PRAISE
          gives a child a clear idea of the behavior a parent likes and wants to
          see again!
        </p>
        <p className='font-bold'>
          Labeled praise is a great way to give attention to a child’s positive
          behavior.
        </p>
      </section>
      <DragonDropWrapper content={data.DragonDrop} />
    </div>
  );
};

export default LabeledPraiseActivity;
